import { render, staticRenderFns } from "./DownloadTrainingReportModal.vue?vue&type=template&id=e872b096&"
import script from "./DownloadTrainingReportModal.vue?vue&type=script&lang=js&"
export * from "./DownloadTrainingReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports